<h2 mat-dialog-title>Exclude Contacts</h2>
<hr class="">
<mat-dialog-content>
  <label><strong>Type or paste each email address on a separate line</strong></label>
  <div class="text-right mb-1">
    <a (click)="clearTextarea()">Clear</a>
  </div>
  <textarea 
  class="form-control"
  rows="6"
  [(ngModel)]="excludedEmails"
  (ngModelChange)="onTextareaChange($event)"
  placeholder="example@email.com
another@email.com"></textarea>

  <div class="text-center my-3 margin-2px"><strong>Or</strong></div>

  <div class="drop-zone mb-3"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (drop)="onDrop($event)"
       [class.active]="dragging">
    <p class="mb-1">Drag and drop CSV here</p>
    <p class="mb-0 text-muted">or click below to upload</p>
  </div>
  
  <label class="upload-label" for="fileInput">Choose File</label>
  <input type="file" id="fileInput" (change)="onFileSelected($event)" accept=".csv" />
  <small class="form-text text-muted">CSV must contain an 'Email' header</small>

  <div *ngIf="invalidEmails.length > 0 || invalidEmailsFromTextarea.length > 0" class="alert alert-warning mt-2">
    <strong>Warning:</strong> {{ invalidEmails.length + invalidEmailsFromTextarea.length }} invalid email{{ invalidEmails.length + invalidEmailsFromTextarea.length > 1 ? 's' : '' }} will be ignored.
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button class="btn-cancel-modal" (click)="onClose()">Close</button>
  <button mat-flat-button class="btn-save-modal"  (click)="onSaveExcluded()" [disabled]="!hasValidEmails">Save</button>
</mat-dialog-actions>